<template>
  <section id="cotizacion">
    <div
      v-if="multimedia[0] != undefined"
      class="cotitrack-fondo extranet-fondo-2"
    >
      <div class="row align-items-center">
        <div class="col-12 col-md-6 d-flex align-items-center justify-content-center justify-content-md-start">
          <div class="cotitrack-contenido extranet-contenidor w-100">
            <div>
              <h1>
                <strong>{{ multimedia[0].title_multimedia }}</strong>
              </h1>
            </div>
            <span v-html="multimedia[0].desc_multimedia"></span>
            <br />
            <div class="cotitrack-texto">
              <a
                id="confirm2"
                :href="multimedia[0].link_button_multimedia"
                target="_blank"
                class="btn-al btn-al-lg btn-al-celeste"
              >
                <strong>{{ multimedia[0].desc_button_multimedia }}</strong>
              </a>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 d-flex align-items-center justify-content-center">
          <div class="cotitrack-contenido extranet-contenido w-100">
            <div class="ratio ratio-16x9 cotitrack-video">
              <iframe
                :src="multimedia[0].link_multimedia"
                title="Guía de compra"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script src="https://cdn.lightwidget.com/widgets/lightwidget.js"></script>
<script>
import axios from "axios";
import { config_settings } from '../../config.js';

export default {
  name: "Instagram",
  data() {
    return {
       multimedia: []
    };
  },
  methods: {
    getMultimedia() {
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/multimedia')
           .then(response => {
             this.multimedia = response.data
            
          })
          .catch(error => {
      })
    }
  },
  //manadatory function called from cardTemplate  
  created() {
    this.getMultimedia()
  }
}

</script>

<style>
#cotizacion {
  padding: 0;
  width: 100%;
}

#cotizacion .cotitrack-fondo {
  display: block !important;
  width: 100% !important;
}

#cotizacion .cotitrack-video {
  width: 100%;
}
</style>
